import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const AbortMultipartVideoUploadApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    body: z.object({
        filename: z.string(),
        requiresStitching: z.coerce.boolean().optional(),
        startTime: z.string().datetime().optional(),
        uploadId: z.string(),
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema.pick({ requestActor: true }),
};
export const AbortMultipartVideoUploadRequestSchema = AbortMultipartVideoUploadApiSchema.params
    .merge(AbortMultipartVideoUploadApiSchema.body)
    .merge(AbortMultipartVideoUploadApiSchema.headers);
